(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mw-model-menu"] && !Shopify.designMode) return;
  try {
    class MwModelMenu extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const buttons = Array.from(this.querySelectorAll('.mw-model-menu__trigger'));
      const panels = Array.from(this.querySelectorAll('.mw-model-menu__panel'));
      const select = (button) => {
        buttons.forEach((item) => item.setAttribute('aria-expanded', String(item === button)));
        panels.forEach((panel) => { panel.hidden = !button || panel.id !== button.getAttribute('aria-controls'); });
        this.querySelector('.mw-model-menu__panels').scrollTop = 0;
      };
      select(null);
      buttons.forEach((button) => {
        button.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') select(button);
        }, options);
        button.addEventListener('focus', () => select(button), options);
        button.addEventListener('click', () => select(button), options);
      });
      this.addEventListener('pointerleave', () => select(null), options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) select(null);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const active = buttons.find((button) => button.getAttribute('aria-expanded') === 'true');
          if (active) {
            event.preventDefault();
            event.stopPropagation();
            active.focus();
            select(null);
          }
        }
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('mw-model-menu')) customElements.define('mw-model-menu', MwModelMenu);
  } catch(e) { console.error(e); }
})();

})();
